<app-loader *ngIf="showLoading"></app-loader>

<div class="main-wrapper">
    <app-header> </app-header>
    <app-leftmenu></app-leftmenu>
    <div class="page-wrapper">
        <div class="content container-fluid">
            <!-- Page Header -->
            <div class="page-header">
                <div class="row align-items-center">
                    <div class="col">
                        <h3 class="page-title">{{PageTitle}}</h3>
                        <ul class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a routerLink="/Dashboard"> Dashboard</a>
                            </li>
                            <li class="breadcrumb-item active">{{PageTitle}}</li>
                        </ul>
                    </div>

                </div>
            </div>
            <!-- /Page Header -->
            <div class="tab-content">

                    <form [formGroup]="ProjectMappingForm">
                                            <!-- Add Prject Mapping -->
                      <div id="ProjectMappingForm" class="pro-overview tab-pane fade show active">
                        <div class="card">
                          <div class="card-body">
                             <div class="col-md-12 mandatory">*Fields are Mandatory</div>
                                <div class="row">
                                    <div class="col-md-4">

                                      <div class="scroll-content boxshadow">
                                              <div class="row align-items-center">
                                                 <div class="col">
                                                    <div class="total-rec">Total Records:
                                                            {{orgRecord}}</div>
                                                            </div>
                                                            <div class="col-auto float-right ml-auto">
                                                                <mat-form-field class="search-input">
                                                                    <input matInput (keyup)="applyFilterOrg($event)"
                                                                        placeholder="Search..." #input>
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
            
                                                        <div class="city-scroll">
                                                            <table mat-table [dataSource]="OrganizationData" matSort
                                                                class="mat-elevation-z8">
            
                                                                <ng-container matColumnDef="selectionvalue">
                                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Organization
                                                                    </th>
                                                                    <td mat-cell *matCellDef="let OrganizationData">
                                                                        <a
                                                                            (click)="SelectORG(OrganizationData.selectionid)">
                                                                            {{OrganizationData.selectionvalue}}
                                                                        </a>
                                                                    </td>
                                                                </ng-container>
            
                                                                <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                                                                <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
            
                                                            </table>
                                                        </div>            
                                                    </div>
                                                </div>
            
            
                                                <div class="col-md-4">
            
                                                    <div class="scroll-content boxshadow" [hidden]="projectFlag">
                                                        <div class="row align-items-center">
                                                            <div class="col">
                                                                <div class="total-rec">Total Records:
                                                                    {{projectRecord}}</div>
                                                            </div>
                                                            <div class="col-auto float-right ml-auto">
                                                                <mat-form-field class="search-input">
                                                                <input matInput (keyup)="applyFilterProject($event)"
                                                                        placeholder="Search..." #input>
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="city-scroll">
                                                        <table mat-table [dataSource]="ProjectData" matSort
                                                            class="mat-elevation-z8">
                                                            <ng-container matColumnDef="checkbox">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                                    <mat-checkbox class="example-margin"
                                                                    (change)="SelectAllProjects($event.checked)"
                                                                type="checkbox">
                                                            </mat-checkbox>  Select All

                                                                </th>
                                                                <td mat-cell *matCellDef="let ProjectData ">
                                                                    <mat-checkbox class="example-margin"
                                                                            (change)="SelectProjects(ProjectData,$event.checked)"
                                                                        type="checkbox">
                                                                    </mat-checkbox>
                                                                    <!-- <input type="checkbox" ng-model="TripData.selected" ng-change="optionToggled(Obj,Obj.selected)"> -->
        
                                                                </td>
                                                            </ng-container>
        
                                                            <ng-container matColumnDef="selectionvalue">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Project
                                                                </th>
                                                                <td mat-cell *matCellDef="let ProjectData">
                                                                    {{ProjectData.selectionvalue}}
                                                                </td>
                                                            </ng-container>
            
                                                            <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                                                            <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
            
                                                        </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
            
                                                    <div class="scroll-content boxshadow" [hidden]="levelFlag">
                                                       <div class="row align-items-center">
                                                            <div class="col">
                                                                <div class="total-rec">Total Records:
                                                                    {{levelRecord}}</div>
                                                            </div>
                                                            <div class="col-auto float-right ml-auto">
                                                                <mat-form-field class="search-input">
                                                                    <input matInput (keyup)="applyFilterLevel($event)"
                                                                        placeholder="Search..." #input>
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="city-scroll">
                                                        <table mat-table [dataSource]="LevelData" matSort
                                                            class="mat-elevation-z8">
                                                            <ng-container matColumnDef="checkbox">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                                    Select
                                                                </th>
                                                                <td mat-cell *matCellDef="let LevelData ">
                                                                    <mat-checkbox class="example-margin" [disabled]="isDisabled"
                                                                        (change)="SelectLevels(LevelData.workflowlevel,$event.checked)"
                                                                        type="checkbox" >
                                                                    </mat-checkbox>
                                                                </td>
                                                            </ng-container>
        
                                                            <ng-container matColumnDef="selectionvalue">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Workflow level
                                                                </th>
                                                                <td mat-cell *matCellDef="let LevelData">
                                                                     {{LevelData.workflowlevel}}
                                                                </td>
                                                            </ng-container>
            
                                                            <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
                                                            <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>
            
                                                        </table>
                                                        </div>
                                                    </div>
                                                </div>
</div>
<br>
<br>
<div class="row" *ngIf="!isAllSelected && displayList.length>0 ">
    <div class="col-md-12" >
        <tr *ngFor="let item of displayList; let i = index ">
            <td>{{i+1}}</td>
            <td>{{item.project}}</td>						
            <td>{{item.level}}</td>	
          </tr>
    </div>
</div>
                                        <div class="submit-section">

                                            <button mat-flat-button color="accent" (click)="addProjectMapping()"
                                                *ngIf="add && !isAllSelected">
                                                <mat-icon aria-hidden="false">save</mat-icon> Save
                                            </button>

                                            <button mat-flat-button color="accent" (click)="addAllProjectMapping()"
                                            *ngIf="add && isAllSelected">
                                            <mat-icon aria-hidden="false">save</mat-icon> Save All
                                        </button>

                                            <button mat-flat-button color="warn" (click)="back()">
                                                <mat-icon aria-hidden="false">cancel</mat-icon> Back
                                            </button>

                                        </div>

                                    </div>


                                </div>
                            </div>
                    </form>
          </div>
    </div>
</div>
</div>